module.exports = __webpack_public_path__ + "b1f6ad735b90c5cfc4a9c43e1a781213.svg";